import dotProp from 'dot-prop-immutable'
import {
  LOAD_ALLCREATORS_PAGES_SUCCESS,
  LOAD_COURSE_PAGES_SUCCESS,
  LOAD_PACKAGE_PAGES_SUCCESS,
  LOAD_DASHBOARD_SUCCESS,
  LOAD_HOME_PAGES_SIDE_SUCCESS,
  LOAD_HOME_PAGES_ALL_SUCCESS,
  LOAD_PROFILE_PAGES_SUCCESS,
  LOAD_PROFILE_PRODUCTS_SUCCESS,
  LOAD_LEVEL_SUCCESS,
  LOAD_CATEGORY_SUCCESS,
  UPDATE_FOLLOW_SUCCESS,
  SEARCH_KEYWORD_SUCCESS,
  ADD_WISHLIST_SUCCESS,
  SUBMIT_REVIEW_SUCCESS,
  DELETE_REVIEW_SUCCESS,
  LOAD_BANNER_DASHBOARD_SUCCESS,
  EDIT_COURSE_SUCCESS,
  EDIT_COURSE_FAILURE,
  RESET_ALERT,
  LOAD_BANNER_SUCCESS,
  CREATE_CONTACTSTAFF_SUCCESS,
  CREATE_CONTACTSTAFF_FAILURE,
  LOAD_EXAMOVERVIEW_SUCCESS,
  LOAD_EXAMOVERVIEW_FAILURE,
  LOAD_EXAMOVERVIEW_REQUEST,
  LOAD_CATEGORYEXAM_SUCCESS,
  LOAD_SCHOOL_SUCCESS,
  LOAD_SCHOOLGET_SUCCESS,
  LOAD_PROVINCESCHOOL_SUCCESS,
  LOAD_INFO_SETTING_PAGES_SUCCESS,
  LOAD_HOME_COURSE_ALL_SUCCESS,
  LOAD_TESTEXAMOVERVIEW_SUCCESS,
  PAYMENT_FAILURE,
  PAYMENT_PAYFORU_SUCCESS,
  LOAD_BANNERALL_SUCCESS,
  LOAD_LIVE_PAGE_SUCCESS,
  LOAD_LIVE_REPLAY_SUCCESS,
  LOAD_LIVE_NOW_SUCCESS,
  LOAD_LIVE_COMING_SUCCESS,
  CLEAR_QRCODE_SUCCESS,
  LOAD_LESSON_SUCCESS,
  // LOAD_QUESTIONEXAM_SUCCESS,
} from '../actions/types'

import { token } from '../utils'

const updateFollowed = (state, action) => {
  let newState = dotProp.set(state, 'profile.following', action.payload.followingStatus)
  return {
    ...newState,
  }
}

const updateIsWishList = (state, action) => {
  let newState = dotProp.set(state, 'product.wishList', action.payload.wishListStatus)
  return {
    ...newState,
  }
}

const updateCommented = (state, action) => {
  let newState = dotProp.merge(state, 'productReview.comments', {
    comment: action.payload.comment,
    customer: action.payload.customer,
    date: action.payload.date,
    isMyComment: token === '' ? false : true,
    rating: action.payload.rating,
    _id: action.payload._id,
  })
  return {
    ...newState,
  }
}

const deleteCommented = (state, action) => {
  const { productReview: currentComment } = state
  const indexComment = currentComment.comments.findIndex(item => item._id === action.payload._id)
  if (indexComment > -1) {
    let newState = dotProp.delete(state, `productReview.comments.${indexComment}`)
    return {
      ...newState,
    }
  }
  return {
    ...state,
  }
}

const updateProduct = (state, {
  payload: {
    product: currentProduct,
    productRelated: currentRelated,
    productReview: currentReview,
    successLecture: currentSuccess,
  },
}) => {
  let product = dotProp.set(state, 'product', currentProduct)
  let tempProduct = dotProp.set(product, 'product.wishList', currentProduct.wishList)
  let productRelated = dotProp.set(tempProduct, 'productRelated', currentRelated)
  let successLecture = dotProp.set(productRelated, 'productReview', currentReview)
  let newState = dotProp.set(successLecture, 'successLecture', currentSuccess)
  return newState
}

const initialPagesState = {
  banners: [],
  // subBannerA: {
  //   _id: '',
  //   bannerImage_3_1: '',
  //   bannerName: '',
  //   title: '',
  //   content: '',
  //   buttonName: '',
  //   productExam: [],
  //   productPackage: [],
  //   creators: [],
  //   type: 'left',
  //   url: '',
  // },
  subBannerA: [],
  lives: {
    currentLive: [],
    comingLive: [],
    previousLive: [],
  },
  coursesNew: [],
  coursesAll: [],
  coursesPopular: [],
  coursesRecommended: [],
  coursePrivate: [],
  coursesAllNoFilter: {
    maxPage: 0,
    products: [],
  },
  qrCodePayment: '',
  qrCodeAmount: 0,
  refId: '',
  packages: [],
  foundProduct: false,
  creators: [],
  posters: [],
  responseCoupon: '',
  successLecture: [],
  product: {
    private: 0,
    expDate: 0,
    exams: {
      timer: 0,
      questions: [],
      choiceFormat: 'th',
      rankstat: {
        _id: '',
        numplayer: 0,
        mean: 0,
        min: 0,
        max: 0,
      },
      totalScore: 0,
    },
    coinPriceDate: [],
    registedCount: 0,
    categoriesExams: [],
    bought: false,
    wishList: null,
    courses: {
      sections: [],
      totalVideo: 0,
      videoLength: 0,
      lesson: `<div class="td-post-content">
      <div class="td-a-rec td-a-rec-id-content_top  td-rec-hide-on-m "><span class="td-adspot-title">- Advertisement -</span><!--/*
*
* Revive Adserver Asynchronous JS Tag
* - Generated with Revive Adserver v4.0.0
*
*/-->
<div id="testTitle">หัวข้อ Lesson</div>
<testTitle>หัวข้อ Lesson</testTitle>
<ins data-revive-zoneid="2" data-revive-id="63358eeec628e48bce0a5b3aec392045" data-revive-seq="1" id="revive-0-1" data-revive-loaded="1" style="text-decoration: none;"><a href="https://www.konthong.com/adserver/www/delivery/ck.php?oaparams=2__bannerid=172__zoneid=2__cb=5ef25982df__oadest=https%3A%2F%2Fwww.konthong.com%2F%E0%B8%84%E0%B8%99%E0%B8%97%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B9%80%E0%B8%82%E0%B9%87%E0%B8%A1%E0%B8%81%E0%B8%A5%E0%B8%B1%E0%B8%94%2F" target="_blank"><img src="https://www.konthong.com/images/83b67b939c068481a03b6eeeac57069f.jpg" width="300" height="250" alt="" title="" border="0" class="td-animation-stack-type0-2"></a><div id="beacon_5ef25982df" style="position: absolute; left: 0px; top: 0px; visibility: hidden;"><img src="https://www.konthong.com/adserver/www/delivery/lg.php?bannerid=172&amp;campaignid=125&amp;zoneid=2&amp;loc=https%3A%2F%2Fwww.konthong.com%2F%25e0%25b8%2599%25e0%25b8%25a1%25e0%25b9%2581%25e0%25b8%259e%25e0%25b8%25b0-3%2F&amp;referer=https%3A%2F%2Fwww.konthong.com%2F&amp;cb=5ef25982df" width="0" height="0" alt="" style="width: 0px; height: 0px;" class="td-animation-stack-type0-2"></div></ins>
<script async="" src="//www.konthong.com/adserver/www/delivery/asyncjs.php"></script></div><p>สงสัยใช่ไหม นมแพะคืออะไร ทำไมจึงเป็นนมที่คุณแม่ส่วนใหญ่เลือก เพื่อเป็นนมเสริมให้กับลูกรักในวัยหย่านม วันนี้เราจะพาคุณไปทำความรู้จักกับนมแพะ และระบบการสร้างน้ำนมของแพะกันว่าเป็นอย่างไร</p>
<p><img class="aligncenter size-full wp-image-10108 td-animation-stack-type0-2" src="https://www.konthong.com/wp-content/uploads/2019/03/นมแพะ.jpg" alt="นมแพะ" width="700" height="427" srcset="https://www.konthong.com/wp-content/uploads/2019/03/นมแพะ.jpg 700w, https://www.konthong.com/wp-content/uploads/2019/03/นมแพะ-300x183.jpg 300w, https://www.konthong.com/wp-content/uploads/2019/03/นมแพะ-696x425.jpg 696w, https://www.konthong.com/wp-content/uploads/2019/03/นมแพะ-689x420.jpg 689w" sizes="(max-width: 700px) 100vw, 700px"></p>
<p>รวมถึงมีสารอาหารที่สำคัญอะไรในนมแพะบ้าง โดยมีข้อมูลดังนี้</p>
<h2><strong>นมแพะ คืออะไร</strong><strong>? </strong></h2>
<p>นมแพะ ก็คือนมที่ได้จากแพะนั่นเอง โดยสายพันธุ์แพะที่ได้รับการยอมรับว่าให้น้ำนมที่มีคุณภาพที่ดีที่สุด ก็คือแพะสายพันธุ์ซาเนน จึงทำให้ได้น้ำนมที่มีคุณภาพและมีสารอาหารสำคัญสูง</p>
<h3><strong>ระบบการสร้างน้ำนมของแพะ เป็นอย่างไร</strong></h3>
<p>ระบบการสร้างน้ำนมของแพะ จะมีความแตกต่างจากสัตว์ให้นมชนิดอื่นๆ อย่างสิ้นเชิง เพราะเป็นการสร้างน้ำนมแบบเดียวกับนมแม่ เรียกว่า อะโพไครน์ (Apocrine) โดยระบบการสร้างน้ำนมแบบอะโพไครน์นี้จะทำให้ได้สารอาหารจากธรรมชาติปนมากับน้ำนมในปริมาณสูง เป็นผลให้นมแพะอุดมไปด้วยสารอาหารที่สำคัญต่อเด็ก คุณพ่อคุณแม่ส่วนใหญ่จึงมักจะเลือกนมแพะ เป็นนมเสริมให้กับลูกรัก</p>
<p>ซึ่งสารอาหารที่ได้จากการสร้างน้ำนมแบบอะโพไครน์ ก็คือ ไบโอแอคทีฟ คอมโพเนนท์ (Bioactive Components) ที่ประกอบไปด้วย</p>
<ol>
<li>นิวคลีโอไทด์ ช่วยเสริมสร้างภูมิคุ้มกัน</li>
<li>ทอรีน ช่วยบำรุงสายตา และจอประสาทตา</li>
<li>โพลีเอมีนส์ ส่งเสริมการทำงานของระบบทางเดินอาหาร</li>
<li>โกรทแฟคเตอร์ ช่วยกระตุ้นการเจริญเติบโต</li>
</ol>
<p>นอกจากนี้ในนมแพะ ก็ยังพบสารอาหารที่มีประโยชน์ต่อเด็กอีกมากมาย ไม่ว่าจะเป็นโปรตีนที่ย่อยง่ายและร่างกายสามารถดูดซึมได้อย่างมีประสิทธิภาพ มีพรีไบโอติกหรือใยอาหารที่ช่วยในการขับถ่าย ทั้งยังมี DHA &amp; ARA ที่จะช่วยเสริมสร้างพัฒนาการทางสมองของลูกรักได้เป็นอย่างดี เพราะฉะนั้นไม่ควรพลาดที่จะเลือกนมแพะให้กับลูกรักของคุณ</p>
<h3><strong>ระบบการสร้างน้ำนมแบบอะโพไครน์ ดีอย่างไร</strong></h3>
<p>สำหรับข้อดีของระบบการสร้างน้ำนมแบบอะโพไครน์ มีดังนี้</p>
<div class="td-a-rec td-a-rec-id-content_inline  "><span class="td-adspot-title">- Advertisement -</span><div class="td-visible-desktop">

<ins data-revive-zoneid="2" data-revive-id="63358eeec628e48bce0a5b3aec392045" data-revive-seq="2" id="revive-0-2" data-revive-loaded="1" style="text-decoration: none;"><a href="https://www.konthong.com/adserver/www/delivery/ck.php?oaparams=2__bannerid=175__zoneid=2__cb=6fe5efd38c__oadest=https%3A%2F%2Fwww.facebook.com%2Fdgsmartclub%2Fvideos%2F337238366915490%2F" target="_blank"><img src="https://www.konthong.com/images/b383b63e476599fbfcb2866eee5954e7.jpg" width="300" height="250" alt="" title="" border="0" class="td-animation-stack-type0-2"></a><div id="beacon_6fe5efd38c" style="position: absolute; left: 0px; top: 0px; visibility: hidden;"><img src="https://www.konthong.com/adserver/www/delivery/lg.php?bannerid=175&amp;campaignid=128&amp;zoneid=2&amp;loc=https%3A%2F%2Fwww.konthong.com%2F%25e0%25b8%2599%25e0%25b8%25a1%25e0%25b9%2581%25e0%25b8%259e%25e0%25b8%25b0-3%2F&amp;referer=https%3A%2F%2Fwww.konthong.com%2F&amp;cb=6fe5efd38c" width="0" height="0" alt="" style="width: 0px; height: 0px;" class="td-animation-stack-type0-2"></div></ins>
<script async="" src="//www.konthong.com/adserver/www/delivery/asyncjs.php"></script></div>
</div><p><strong>1.</strong><strong>ได้สารอาหารจากธรรมชาติครบถ้วน</strong></p>
<p>หากเปรียบเทียบระหว่างการสร้างน้ำนมแบบอะโพไครน์ และแบบเมโรไครน์ของสัตว์ให้นมทั่วไปแล้ว พบว่าการสร้างน้ำนมแบบอะโพไครน์ (Apocrine) จะมีบทบาทมากในน้ำนมแพะ (Wooding and Peaker LINZELL 1970) ดังนั้น น้ำนมจากแพะจึงประกอบไปด้วยชิ้นส่วนเซลล์ที่หลุดออกมาในระหว่างการสร้างน้ำนมแบบอะโพไครน์ (Wooding and Peaker LINZELL 1970; Wooding, Morgan et al. 1977) ซึ่งเป็นสารอาหารจากธรรมชาติ จึงทำให้นมแพะมีสารอาหารจากธรรมชาติครบถ้วน</p>
<p><strong>2.</strong><strong>ช่วยเสริมภูมิคุ้มกัน </strong></p>
<p>ระบบสร้างน้ำนมแบบอะโพไครน์ จะทำให้ได้สารอาหารที่เรียกว่านิวคลีโอไทด์ ซึ่งมีความสำคัญในการช่วยเสริมภูมิคุ้มกัน จึงทำให้เด็กมีสุขภาพที่แข็งแรง ไม่เจ็บป่วยบ่อย</p>
<p><strong>3.</strong><strong>บำรุงสายตาและสมอง </strong></p>
<p>มีส่วนช่วยในการบำรุงสายตา และสมองได้เป็นอย่างดี เพราะมีทอรีนที่มีคุณสมบัติในการบำรุงจอประสาทตา พร้อมทั้งเสริมสร้างพัฒนาการทางสมองได้</p>
<p><strong>4.</strong><strong>ส่งเสริมการทำงานของระบบทางเดินอาหาร</strong></p>
<p>เนื่องจากในนมแพะมีโพลีเอมีนส์ จึงสามารถส่งเสริมการทำงานของระบบทางเดินอาหารได้อย่างมีประสิทธิภาพ ช่วยให้เกิดการย่อยและขับถ่ายง่ายขึ้น ลดปัญหาต่างๆ ที่เกิดกับระบบทางเดินอาหารได้ดี</p>
<p><strong>5.</strong><strong>ช่วยในการเจริญเติบโตและส่งเสริมพัฒนาการได้ดี</strong></p>
<p>น้ำนมที่ได้จากการสร้างน้ำนมแบบอะโพไครน์ จะช่วยในการเจริญเติบโตและพัฒนาการที่ดีให้กับเด็กได้อย่างดีเยี่ยม เพราะมีโกรทแฟคเตอร์ ที่ได้จากกระบวนการสร้างน้ำนมแบบอะโพไครน์ จึงทำให้ลูกรักเติบโตอย่างสมวัย ไม่ว่าจะเป็นพัฒนาการทางด้านร่างกายหรือสมองก็ตาม</p>
<p>ลูกรักจะแข็งแรงและเติบโตอย่างสมวัย แค่เลือกสิ่งที่ดีที่สุดให้กับเขา ดังนั้นมาเลือกนมแพะให้กับลูกรักของคุณกันเถอะ โดยเฉพาะเมื่อลูกหย่านมแม่แล้ว หรือกรณีที่คุณแม่ไม่สามารถให้นมลูกได้ นมแพะก็จะเป็นคำตอบที่ดีที่สุดสำหรับคุณ</p>
<p>อ้างอิง acfs.go.th, healthline.com, sciencedirect.com</p>
<p>==========</p>
<p><strong>ติดตามความรู้ดี ๆ &nbsp;และสาระดี ๆ เพิ่มเติมสำหรับแม่ตั้งครรภ์และลูกน้อย ได้ที่ &nbsp;</strong><span style="color: #ff00ff;"><a style="color: #ff00ff;" href="https://www.konthong.com/" target="_blank" rel="noopener"><strong>www.konthong.com</strong></a></span><strong>&nbsp;</strong><strong>หรือ ร่วมพูดคุยแลกเปลี่ยนกันได้ที่</strong><strong>&nbsp;</strong><span style="color: #ff00ff;"><a style="color: #ff00ff;" href="https://www.facebook.com/teamkonthong/" target="_blank" rel="noopener"><strong>https://www.facebook.com/teamkonthong/</strong></a></span></p>
<div class="td-a-rec td-a-rec-id-content_bottom  td-rec-hide-on-m "><!--/*
*
* Revive Adserver Asynchronous JS Tag
* - Generated with Revive Adserver v4.0.0
*
*/-->

<ins data-revive-zoneid="3" data-revive-id="63358eeec628e48bce0a5b3aec392045" data-revive-seq="3" id="revive-0-3" data-revive-loaded="1" style="text-decoration: none;"><a href="https://www.konthong.com/adserver/www/delivery/ck.php?oaparams=2__bannerid=173__zoneid=3__cb=a5768a0ed7__oadest=http%3A%2F%2Fline.me%2Fti%2Fp%2F%2540tcb5905v" target="_blank"><img src="https://www.konthong.com/images/9c7697a124ed8865c2a5eea155620e9e.gif" width="300" height="250" alt="" title="" border="0" class="td-animation-stack-type0-2"></a><div id="beacon_a5768a0ed7" style="position: absolute; left: 0px; top: 0px; visibility: hidden;"><img src="https://www.konthong.com/adserver/www/delivery/lg.php?bannerid=173&amp;campaignid=126&amp;zoneid=3&amp;loc=https%3A%2F%2Fwww.konthong.com%2F%25e0%25b8%2599%25e0%25b8%25a1%25e0%25b9%2581%25e0%25b8%259e%25e0%25b8%25b0-3%2F&amp;referer=https%3A%2F%2Fwww.konthong.com%2F&amp;cb=a5768a0ed7" width="0" height="0" alt="" style="width: 0px; height: 0px;" class="td-animation-stack-type0-2"></div></ins>
<script async="" src="//www.konthong.com/adserver/www/delivery/asyncjs.php"></script></div>        </div>`,
    },
    examtests: {
      timer: 0,
      questions: [],
      choiceFormat: 'th',
      rankstat: {
        _id: '',
        numplayer: 0,
        mean: 0,
        min: 0,
        max: 0,
      },
    },
    promotional: {
      imageURL: '',
      videoURL: '',
    },
    rating: {
      avg: 0,
      user: 0,
    },
    uploaders: [
      {
        displayName: '',
        imageURL: 'http://db1.deknerd.com:8080/api/v1.0/image/profile/deknerd.png',
        language: '',
      },
    ],
    category: [],
    levels: [],
    comments: [],
    products: [],
  },
  productReview: {
    comments: [],
    rating1: 0,
    rating2: 0,
    rating3: 0,
    rating4: 0,
    rating5: 0,
  },
  productRelated: {
    creatorProducts: [{
      promotional: {
        imageURL: 'http://db1.deknerd.com:8080/api/v1.0/image/profile/deknerd.png',
      },
      slugName: '',
      productName: '',
      rating: {
        user: '',
        avg: 0,
      },
      description: '',
      uploaders: [{
        displayName: '',
      }],
    }],
    courseRecommended: [],
    productRecommended: [{
      promotional: {
        imageURL: 'http://db1.deknerd.com:8080/api/v1.0/image/profile/deknerd.png',
      },
      slugName: '',
      productName: '',
      rating: {
        user: '',
        avg: 0,
      },
      description: '',
      uploaders: [{
        displayName: '',
      }],
    }],
    productsInCategory: [{
      promotional: {
        imageURL: 'http://db1.deknerd.com:8080/api/v1.0/image/profile/deknerd.png',
      },
      slugName: '',
      productName: '',
      rating: {
        user: '',
        avg: 0,
      },
      description: '',
    }],
  },
  profile: {
    blogsCount: 0,
    booksCount: 0,
    coursesCount: 0,
    displayName: '',
    followers: 1,
    following: false,
    imageURL: '',
    shortDesc: '',
    _id: '',
  },
  products: [],
  productsCreator: {
    courses: [],
    exams: [],
  },
  searchs: {
    courses: [],
    exams: [],
    books: [],
    blogs: [],
    creators: [],
  },
  info: {
    creator: {
      blogs: [],
      books: [],
      courses: [],
      followers: [],
    },
  },
  categories: [{
    _id: '0',
    name: 'ทั้งหมด',
  }],
  levels: [],
  level: [],
  provinces: [],
  schools: [],
  sortType: [
    {
      value: 'name',
      name: 'ชื่อ',
    },
    {
      value: 'follower',
      name: 'จำนวนผู้ติดตาม',
    },
  ],
  flashMessage: {
    status: '',
    active: 0,
    message: '',
  },
  maxPage: 3,
  // bannerTutor: [],
  bannerTutor: [],
}

const pages = (state = initialPagesState, action) => {
  switch (action.type) {
    case LOAD_HOME_PAGES_SIDE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case LOAD_HOME_PAGES_ALL_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
      case LOAD_LIVE_PAGE_SUCCESS:
      {
        return {
          ...state,
          lives: {
            ...action.payload,
          },
        }
      }
    case SEARCH_KEYWORD_SUCCESS:
      return {
        ...state,
        searchs: action.payload,
      }
    case LOAD_LEVEL_SUCCESS:
      return {
        ...state,
        levels: [
          ...state.levels,
          ...action.payload,
        ],
      }
    case LOAD_PROVINCESCHOOL_SUCCESS:
      {
        return {
          ...state,
          provinces: action.payload,
        }
      }
    case LOAD_SCHOOL_SUCCESS:
      return {
        ...state,
        schools: action.data,
      }
    case LOAD_SCHOOLGET_SUCCESS:
      return {
        ...state,
        schools: action.payload,
      }
    case LOAD_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: [
          ...state.categories,
          ...action.payload.categories,
        ],
      }
    case PAYMENT_FAILURE:
    {
      return {
        ...state,
        responseCoupon: action.payload,
      }
    }
    case LOAD_COURSE_PAGES_SUCCESS:
      return updateProduct(state, action)
    case LOAD_PACKAGE_PAGES_SUCCESS:
      return updateProduct(state, action)
    case LOAD_PROFILE_PAGES_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }
    case LOAD_PROFILE_PRODUCTS_SUCCESS:
      return {
        ...state,
        productsCreator: {
          courses: action.payload.courses,
          exams: action.payload.exams,
        },
      }
    case LOAD_ALLCREATORS_PAGES_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case UPDATE_FOLLOW_SUCCESS:
      return updateFollowed(state, action)
    case ADD_WISHLIST_SUCCESS:
      return updateIsWishList(state, action)
    case LOAD_DASHBOARD_SUCCESS:
      return {
        ...state,
        info: action.payload,
      }
    case SUBMIT_REVIEW_SUCCESS: return updateCommented(state, action)
    case DELETE_REVIEW_SUCCESS:
      return deleteCommented(state, action)
    case LOAD_BANNER_DASHBOARD_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case PAYMENT_PAYFORU_SUCCESS:
      return {
        ...state,
        qrCodePayment: action.data.qrcode_text,
        qrCodeAmount: action.data.amount,
        refId: action.data.refId,
      }
    case CLEAR_QRCODE_SUCCESS: {
      return {
        ...state,
        qrCodePayment: initialPagesState.qrCodePayment,
        qrCodeAmount: initialPagesState.qrCodeAmount,
        refId: initialPagesState.refId,
      }
    }
    case EDIT_COURSE_SUCCESS:
      return {
        ...state,
        flashMessage: {
          active: 1,
          message: 'บันทึกเรียบร้อย',
          status: 'success',
        },
      }
    case EDIT_COURSE_FAILURE:
      return {
        ...state,
        flashMessage: {
          active: 2,
          message: 'ผิดพลาด',
          status: 'error',
        },
      }
    case RESET_ALERT:
      return {
        ...state,
        flashMessage: initialPagesState.flashMessage,
      }
    // case LOAD_BANNER_SUCCESS:
    //   return {
    //     ...state,
    //     bannerTutor: [
    //       ...state.bannerTutor,
    //       ...action.payload,
    //     ],
    //     // bannerTutor: initialPagesState.bannerTutor,
    //   }
    case LOAD_BANNER_SUCCESS:
      {
        return {
          ...state,
          banners: [
            ...action.payload,
          ],
        }
      }
    case CREATE_CONTACTSTAFF_SUCCESS:
      return {
        ...state,
        flashMessage: {
          active: 1,
          message: 'บันทึกเรียบร้อย',
          status: 'success',
        },
      }
    case CREATE_CONTACTSTAFF_FAILURE:
      return {
        ...state,
        flashMessage: {
          active: 2,
          message: 'ผิดพลาด',
          status: 'error',
        },
      }
    case LOAD_EXAMOVERVIEW_SUCCESS:
      {
        return {
          ...state,
          ...action.payload,
          foundProduct: true,
        }
      }
    case LOAD_EXAMOVERVIEW_REQUEST:
      {
        return {
          ...state,
          ...action.payload,
          foundProduct: true,
        }
      }
    case LOAD_EXAMOVERVIEW_FAILURE:
      {
        return {
          ...state,
          foundProduct: false,
        }
      }
    case LOAD_TESTEXAMOVERVIEW_SUCCESS:
      {
        return {
          ...state,
          ...action.payload,
        }
      }
    case LOAD_INFO_SETTING_PAGES_SUCCESS:
      {
        return {
          ...state,
          schools: [...state,
            // action.payload.school !== null ? action.payload.school : '',
            action.payload.school !== undefined ? action.payload.school : '',
          ],
        }
      }
    case LOAD_CATEGORYEXAM_SUCCESS:
      {
        return {
          ...state,
          banners: action.payload.banners,
        }
      }
    case LOAD_HOME_COURSE_ALL_SUCCESS:
      {
        return {
          ...state,
          coursesAllNoFilter: {
            maxPage: action.payload.maxPage,
            products: [
              ...state.coursesAllNoFilter.products,
              action.payload.products] },
        }
      }
    case LOAD_BANNERALL_SUCCESS:
      {
        return {
          ...state,
          banners: action.payload
        }
      }
    case LOAD_LIVE_REPLAY_SUCCESS:
      {
        return {
          ...state,
          lives: {
            ...state.lives,
            previousLive: action.payload,
          }
        }
      }
    case LOAD_LESSON_SUCCESS:
      {
        return {
          ...state,
          product: {
            ...state.product,
            courses: {
              ...state.product.courses,
              lesson: action.payload,
            },
          },
        }
      }
    case LOAD_LIVE_NOW_SUCCESS:
      {
        return {
          ...state,
          lives: {
            ...state.lives,
            currentLive: action.payload,
          }
        }
      }
    case LOAD_LIVE_COMING_SUCCESS:
      {
        return {
          ...state,
          lives: {
            ...state.lives,
            comingLive: action.payload,
          }
        }
      }
    default:
      return state
  }
}

export default pages



// WEBPACK FOOTER //
// ./src/reducers/pages.js